import React, { Component } from "react";
import { MainTabBar } from "./mainTabBar";
import {
  Footer, FormArea,
  NavBar,
  NavBarItem,
  Tab,
  TabPanel
} from "../../components/weui";
import { selectLogo, store } from "../../stores";

export class Layout extends Component {
  static displayName = Layout.name;

  state = {
    navCur: 0
  };

  render() {
    const isNavActive = c => this.state.navCur === c;
    const navBarClick = c => this.setState({ navCur: c });
    const logo = selectLogo(store.getState());
    return (
      <Tab>
        <NavBar className="hidden">
          <NavBarItem active={ isNavActive(0) } onClick={ e => navBarClick(0) }>haha1</NavBarItem>
          <NavBarItem active={ isNavActive(1) } onClick={ e => navBarClick(1) }>haha2</NavBarItem>
          <NavBarItem active={ isNavActive(2) } onClick={ e => navBarClick(2) }>haha3</NavBarItem>
        </NavBar>

        <TabPanel>
          { this.props.children }
          <FormArea type="extra">
            <Footer copyright={ logo?.copyright } />
          </FormArea>
        </TabPanel>

        <MainTabBar />
      </Tab>
    );
  }
}
